import Promise from 'promise-polyfill';

export default Promise;
